export default __webpack_public_path__ + "static/B0153-e3d130a9d7fad55410e3915c338b2f5f.png";